import React, { useState } from "react";
import { EnergyProfileWelcomePage } from "../../../settings/energy-profile/energy-profile-welcome-page/EnergyProfileWelcomePage";
import { EnergyProfileCreatePage, EnergyProfileEditPageNinState } from "../../../settings/energy-profile/energy-profile-create-page/EnergyProfileCreatePage";
import { NinVerificationPage } from "../../../settings/energy-profile/nin-verification/NinVerificationPage";

interface Props {
	onComplete: () => void;
}

/**
 * Sign-up Energy Profile step. Reuses the existing energy-profile setup screens
 * in embedded mode and drives them through an internal phase machine
 * (landing → edit → nin), mirroring Step6SharedAccount. Any exit path
 * (skip, save-for-later, or successful NIN verification) calls `onComplete` to
 * advance the sign-up flow.
 */
export const Step5EnergyProfile: React.FC<Props> = ({ onComplete }) => {
	const [phase, setPhase] = useState<"landing" | "edit" | "nin">("landing");
	const [ninState, setNinState] = useState<EnergyProfileEditPageNinState>();

	if (phase === "landing") {
		return <EnergyProfileWelcomePage embedded onContinue={() => setPhase("edit")} onSkip={onComplete} />;
	}

	if (phase === "edit") {
		return (
			<EnergyProfileCreatePage
				embedded
				onProceedToNin={state => {
					setNinState(state);
					setPhase("nin");
				}}
				onSkip={onComplete}
			/>
		);
	}

	return (
		<NinVerificationPage
			embedded
			pageState={
				ninState
					? { meterNumber: ninState.meterNumber, isLandlord: ninState.isLandlord, consumerType: ninState.consumerType ?? undefined }
					: undefined
			}
			onComplete={onComplete}
			onBack={() => setPhase("edit")}
		/>
	);
};
